// Klucze tłumaczeń (`uiCommon:*`) dla typu aktywności z Apple Health / Health Connect. Wspólne dla
// apki (lista treningów do powiązania) i admina (szczegóły powiązanego treningu w kalendarzu).
const HEALTH_WORKOUT_ACTIVITY_LABELS: Record<string, string> = {
  AMERICAN_FOOTBALL: "uiCommon:american-football",
  ARCHERY: "uiCommon:archery",
  AUSTRALIAN_FOOTBALL: "uiCommon:australian-football",
  BADMINTON: "uiCommon:badminton",
  BASEBALL: "uiCommon:baseball",
  BASKETBALL: "uiCommon:basketball",
  BIKING: "uiCommon:cycling",
  BIKING_STATIONARY: "uiCommon:stationary-cycling",
  BOWLING: "uiCommon:bowling",
  BOXING: "uiCommon:boxing",
  CALISTHENICS: "uiCommon:calisthenics",
  CARDIO_DANCE: "uiCommon:cardio-dance",
  CLIMBING: "uiCommon:climbing",
  CORE_TRAINING: "uiCommon:core-training",
  CRICKET: "uiCommon:cricket",
  CROSS_TRAINING: "uiCommon:cross-training",
  CYCLING: "uiCommon:cycling",
  DANCE: "uiCommon:dance",
  ELLIPTICAL: "uiCommon:elliptical",
  EXERCISE_CLASS: "uiCommon:fitness-class",
  FENCING: "uiCommon:fencing",
  FLEXIBILITY: "uiCommon:mobility",
  FOOTBALL_AMERICAN: "uiCommon:american-football",
  FOOTBALL_AUSTRALIAN: "uiCommon:australian-football",
  FUNCTIONAL_STRENGTH_TRAINING: "uiCommon:functional-training",
  GOLF: "uiCommon:golf",
  GYMNASTICS: "uiCommon:gymnastics",
  HANDBALL: "uiCommon:handball",
  HIGH_INTENSITY_INTERVAL_TRAINING: "uiCommon:hiit",
  HIKING: "uiCommon:hiking",
  ICE_HOCKEY: "uiCommon:hockey",
  JUMP_ROPE: "uiCommon:skipping-rope",
  KICKBOXING: "uiCommon:kickboxing",
  MARTIAL_ARTS: "uiCommon:martial-arts",
  MIXED_CARDIO: "uiCommon:cardio",
  MIXED_METABOLIC_CARDIO_TRAINING: "uiCommon:metabolic-training",
  OTHER: "uiCommon:other-workout",
  OTHER_WORKOUT: "uiCommon:other-workout",
  PILATES: "uiCommon:pilates",
  PREPARATION_AND_RECOVERY: "uiCommon:warm-up-and-recovery",
  ROWING: "uiCommon:rowing",
  ROWING_MACHINE: "uiCommon:rowing-machine",
  RUGBY: "uiCommon:rugby",
  RUNNING: "uiCommon:running",
  RUNNING_TREADMILL: "uiCommon:treadmill",
  SKATING: "uiCommon:ice-skating-roller-skating",
  SKIING: "uiCommon:skiing",
  SOCCER: "uiCommon:football",
  SQUASH: "uiCommon:squash",
  STAIR_CLIMBING: "uiCommon:stair-climbing",
  STAIR_CLIMBING_MACHINE: "uiCommon:stair-stepper",
  STRENGTH_TRAINING: "uiCommon:strength-training",
  STRETCHING: "uiCommon:stretching",
  SWIMMING_OPEN_WATER: "uiCommon:open-water-swimming",
  SWIMMING_POOL: "uiCommon:pool-swimming",
  TABLE_TENNIS: "uiCommon:table-tennis",
  TENNIS: "uiCommon:tennis",
  TRADITIONAL_STRENGTH_TRAINING: "uiCommon:strength-training",
  VOLLEYBALL: "uiCommon:volleyball",
  WALKING: "uiCommon:walking",
  WEIGHTLIFTING: "uiCommon:weightlifting",
  YOGA: "uiCommon:yoga",
};

const APPLE_HEALTH_WORKOUT_ACTIVITY_LABELS: Record<string, string> = {
  "1": "uiCommon:american-football",
  "4": "uiCommon:badminton",
  "6": "uiCommon:basketball",
  "8": "uiCommon:boxing",
  "9": "uiCommon:climbing",
  "11": "uiCommon:cross-training",
  "13": "uiCommon:cycling",
  "14": "uiCommon:dance",
  "20": "uiCommon:functional-training",
  "24": "uiCommon:hiking",
  "28": "uiCommon:martial-arts",
  "30": "uiCommon:metabolic-training",
  "35": "uiCommon:rowing",
  "37": "uiCommon:running",
  "41": "uiCommon:football",
  "44": "uiCommon:stair-climbing",
  "46": "uiCommon:swimming",
  "48": "uiCommon:tennis",
  "50": "uiCommon:strength-training",
  "52": "uiCommon:walking",
  "57": "uiCommon:yoga",
  "59": "uiCommon:core-training",
  "63": "uiCommon:hiit",
  "64": "uiCommon:skipping-rope",
  "66": "uiCommon:pilates",
  "68": "uiCommon:stair-climbing",
  "73": "uiCommon:cardio",
  "80": "uiCommon:cool-down",
  "3000": "uiCommon:other-workout",
};

const HEALTH_CONNECT_WORKOUT_ACTIVITY_LABELS: Record<string, string> = {
  "0": "uiCommon:other-workout",
  "8": "uiCommon:cycling",
  "9": "uiCommon:stationary-cycling",
  "11": "uiCommon:boxing",
  "13": "uiCommon:calisthenics",
  "16": "uiCommon:dance",
  "25": "uiCommon:elliptical",
  "36": "uiCommon:hiit",
  "37": "uiCommon:hiking",
  "41": "uiCommon:skipping-rope",
  "44": "uiCommon:martial-arts",
  "48": "uiCommon:pilates",
  "53": "uiCommon:rowing",
  "54": "uiCommon:rowing-machine",
  "56": "uiCommon:running",
  "57": "uiCommon:treadmill",
  "64": "uiCommon:football",
  "68": "uiCommon:stair-climbing",
  "69": "uiCommon:stair-stepper",
  "70": "uiCommon:strength-training",
  "71": "uiCommon:stretching",
  "73": "uiCommon:open-water-swimming",
  "74": "uiCommon:pool-swimming",
  "76": "uiCommon:tennis",
  "79": "uiCommon:walking",
  "81": "uiCommon:weightlifting",
  "83": "uiCommon:yoga",
};

const normalizeActivityType = (activityType: string) =>
  activityType
    .trim()
    .replace(/([a-z0-9])([A-Z])/g, "$1_$2")
    .replace(/[\s-]+/g, "_")
    .toUpperCase();

/** Klucz tłumaczenia typu aktywności albo `null`, gdy źródło nie podało typu. */
export const getHealthWorkoutActivityLabelKey = (
  provider: string | null | undefined,
  activityType: string | null | undefined,
): string | null => {
  if (!activityType) {
    return null;
  }

  const providerNumericLabels =
    provider === "apple-health" ? APPLE_HEALTH_WORKOUT_ACTIVITY_LABELS : HEALTH_CONNECT_WORKOUT_ACTIVITY_LABELS;

  return (
    providerNumericLabels[activityType] ??
    HEALTH_WORKOUT_ACTIVITY_LABELS[activityType] ??
    HEALTH_WORKOUT_ACTIVITY_LABELS[normalizeActivityType(activityType)] ??
    "uiWorkouts:health-workout"
  );
};
